import React from 'react';
import ReactDOM from 'react-dom';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { UxContext } from './UxContext';

const Loading = () => {
    const uxCtx = React.useContext(UxContext);
    const isLoading = uxCtx?.isLoading;

    if (isLoading) {
        return ReactDOM.createPortal(
            <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: 'common.white' }} open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>,
            document.querySelector('#loading') as Element
        );
    }

    return null;
};

export default Loading;
